export default __webpack_public_path__ + "static/media/link3.797431ab.png";